module.exports = __webpack_public_path__ + "static/img/FL-Logo-02.12dae30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/FL-Logo-02.png
// module id = M4md
// module chunks = 1